import { render } from "./AppLoader.vue?vue&type=template&id=1afc36b3"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import "./AppLoader.vue?vue&type=style&index=0&id=1afc36b3&lang=scss"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__